import { render } from "./customerSliderComponent.vue?vue&type=template&id=2193b364&scoped=true"
import script from "./customerSliderComponent.vue?vue&type=script&lang=js"
export * from "./customerSliderComponent.vue?vue&type=script&lang=js"

import "./customerSliderComponent.vue?vue&type=style&index=0&id=2193b364&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2193b364"]])

export default __exports__